<template>
    <table class="favoriten">
        <colgroup>
            <col />
            <col />
            <col />
            <col width='1px' />
            <col width='1px' />
        </colgroup>
        <tr>
            <th>ARTIKELBEZEICHNUNG</th>
            <th>ARTIKEL-NR.</th>
            <th>PREIS</th>
            <th>BESTELLEN</th>
            <th>ENTFERNEN</th>
        </tr>
        <favoriten-row v-for="item in items" :key="item.rowId" :item="item"></favoriten-row>
    </table>
</template>

<script>
export default {
    data() {
        return {
            items: {}
        }
    },
    created() {
        App.event.listen('favoriten.data.loaded', (response) => {
            this.items = response.items;
        });

        App.event.listen('favoriten.updated', (response) => {
            this.items = response.items
        });
    }
}
</script>
